export interface HarmonicFilterDto {
  id: string;
  name: string;
}

export interface BOHEquipment {
  boh: string;
  id: string;
  length: number;
  od: number;
  pn: number;
  series: string;
  tubing: string;
  tubingOD: number;
  weight: number;
  text: string
}

export interface SelectOptions {
  id: string;
  name: string;
};
export interface IPRplotData {
  compositePi: Array<IPR_PlotSampleData>
  constantPi: Array<IPR_PlotSampleData>
  vogel: Array<IPR_PlotSampleData>
  wiggins: Array<IPR_PlotSampleData>
  x_Plot_MaxValue: number
  y_PlotMaxValue: number
  x_Plot_Interval: number
  y_Plot_Interval: number
}
export interface IPRPlotData {
  compositePi: Array<IPR_PlotSampleData>
  constantPi: Array<IPR_PlotSampleData>
  vogel: Array<IPR_PlotSampleData>
  wiggins: Array<IPR_PlotSampleData>
  x_Plot_MaxValue: string
  y_PlotMaxValue: string
  x_Plot_Interval: string
  y_Plot_Interval: string
}
export interface IPR_PlotSampleData {
  fbhp: number,
  liquidRate: number
}
export interface CompositeCurveCalculationOutput {
  Mainpumpid: string
  MainPmpNumberOfStages: number
  CompositePumpFlowCorrection: number
  CompositePumpHeadCorrection: number
  CompositePumpPowerCorrection: number
  CompositeSpGravity: number
  Viscosity: number
  ViscosityUnit: number
  Operatingfrequency: number
  MotorSpeed: number
  ProductionRate: number
  ProductionrateUnit: number
  Unitsystem: number
  FinalTDH: number
  GKXpumpId: string
  FluidSpGravity: number
  GKXNumberOfStage: number
  ChargePump1Id: string
  ChargePump2Id: string
  ChargePump3Id: string
  ChargePmp1NoOfStage: number
  ChargePmp2NoOfStage: number
  ChargePmp3NoOfStage: number
}
export interface CompostiteCurveGraphData {
  head: Array<number[]>
  bhp: Array<number[]>
  efficiency: Array<number[]>
  plotFormatData: Array<string>
  min: Array<number[]>
  bep: Array<number[]>
  max: Array<number[]>
  target: Array<number[]>
  targetH: Array<number[]>
  targetV: Array<number[]>
}
export interface CompPumpInputCalculated {
  compositeFlowCorrectionFactor: number
  compositePowerCorrectionFactor: number
  compositeHeadCorrectionFactor: number
}

export interface Country {
  id: string;
  countryName: string;
};

export interface CountryData {
  id: string;
  countryName: string;
  countryCode: string;
};

export interface StateData {
  stateID: number;
  stateName: string;
};

export interface HelpOutObject {
  description: string;
  link: string;
  className: string;
};

export interface Tab3Input {
  spGrWater?: number;
  waterCut?: number;
  bwpd?: number;
  oilAPI?: number;
  spGrOil?: number;
  oilCut: number;
  bopd?: number;
  averageCombinedSpGr: number;
  liquidPhaseCombinedSpGr: number;
  combinedSpGr: number;
  fluidViscosity?: number | string;
  gasAvailblty: string
  gasProduction?: number;
  gor?: number;
  glr?: number;
  spGrGas?: number;
  bubblePoint?: number;
  bottomHoleTemp?: number;
  surfaceTemperature?: number;
  operatngFreq?: string | number;
  stackWater?: number;
  isOilAPI: boolean;
  stackOil: number;
  isGasProduction: boolean;
  selctedGasProdctn: string;
  gorOverride?: number;
  gasCompressibility?: number;
  heatCorrectionNo: number;
  cableSize: number;
  cableSizeList: string;
  cableGage: string;
  estimatedCableLength: number;
  primaryVoltage: number;
  unitBOPDListVal: string;
  unitBOPDList: object;
  unitBWPDListVal: string;
  unitBWPDList: object;
  unitBottomHoleTempListVal: string;
  unitBottomHoleTempList: object;
  unitBubblePointListVal: number
  unitBubblePointList: object;
  unitGORListVal: string;
  unitGORList: object;
  unitGLRListVal: string;
  unitGOROverrideListVal: string;
  unitGOROverrideList: object;
  unitGasProductionListVal: string;
  unitGasProductionList: object;
  unitStackOilListVal: string;
  unitStackOilList: object;
  unitStackWaterListVal: string;
  unitStackWaterList: object;
  unitWaterCutListVal: string;
  unitWaterCutList: object;
  unitEstimatedCableLengthListVal: string;
  unitEstimatedCableLengthList: object;
  unitFluidViscosityListVal: string;
  unitFluidViscosityList: object;
  unitGasCompressibilityListVal: string;
  unitSurfaceTemperatureListVal: string;
  actNameStackWater: string;
  actNameWaterCut: string;
  actNameBWPD: string;
  actNameStackOil: string;
  actNameBOPD: string;
  actNameFluidViscosity: string;
  actNameGasProduction: string;
  actNameGOR: string;
  actNameGLR: string;
  actNameBubblePoint: string;
  actNameBottomHoleTemp: string;
  actNameSurfaceTemp: string;
  actNameOperatingFrequency: string;
  hiddenOilIPType: string;
  hiddenGasIPType: string;
  hdnAutoGasCmpress: string;
  hdnAutoBBlPnt: string;
  helpSpGrWater: HelpOutObject;
  helpWaterCut: HelpOutObject;
  helpBWPD: HelpOutObject;
  helpOilProperty: HelpOutObject;
  helpOilCut: HelpOutObject;
  helpBOPD: HelpOutObject;
  helpCompSpGr: HelpOutObject;
  helpFluidViscosity: HelpOutObject;
  helpGasAvailability: HelpOutObject;
  helpGasAmount: HelpOutObject;
  helpSpGrGas: HelpOutObject;
  helpGasCompressibility: HelpOutObject;
  helpBubblePoint: HelpOutObject;
  helpBottomHoleTemp: HelpOutObject;
  helpSurfaceTemp: HelpOutObject;
  helpOperatingFrequency: HelpOutObject;
}

export interface RegionItem {
  id: string;
  name: string;
};
export interface PumpCalcModel {
  bepFlow: string
  bhpPerStage: string
  effeciency: string
  hsShaftHPLimit: string
  pumpID: string
  liftPerStage: string
  maximumOperatingBPD: string
  minimumOperatingBPD: string
  numberOfStages: string
  pumpName: string
  shaftDiameter: string
  standardShaftHPLimit: string
  totalBHP: string
  pumpImpellar: string
  pumpSeries: string
  tableRow: Equipment[]
  housingType?: string
}
export interface PumpInput {
  pump_SpGravity?: number
  pump_FldViscosity?: number
  pump_OperatngFreq?: number
  pump_FullLoadSp?: number
  pump_DesredFlwRate?: number
  pump_ReqdTDH?: number
  pump_DesrdStges?: number
  pump_PumpName: string
  pump_ShaftType?: number
  pumpFlowCorrection?: number
  pumpHeadCorrection?: number
  pumpPowerCorrection?: number
  unitPmp_DesrdFlRate: string
  unitPmp_FldViscty: string
  unitPmp_HP3500: string
  unitPmp_MtrFlSpd: string
  unitPmp_OperatngFrq: string
  unitPmp_ReqTDH: string
  unitPmp_LftPrStage: string
  actNamePump_DesiredFlowRate: string
  actNamePump_FluidViscosity: string
  actNamePump_HP3500: string
  actNamePump_MotorFullSpeed: string
  actNamePump_OperatingFrequency: string
  actNamePump_RequiredTDH: string
  actNamePump_LiftPerStage: string
  actNamePump_Pmax: string
  actNamePump_PressureLimit: string
  installationType: string
  estimatedCurrentAmps: number
  filterSelection: HarmonicFilterDto
  compositePumpFlowCorrection?: number
  compositePumpHeadCorrection?: number
  compositePumpPowerCorrection?: number
}
export interface PumpInputCalculated {
  IPumpFreeGasWarningVisible?: boolean
  minNoOfStages: string
  ftLftPerStage: string
  flwCrrctnForPump: string
  hdCrrctnForPump: string
  pWRCrrctnForPump: string
  hPOPPump: string
  hPOPPump60Hz: string
  pmpFinalTDH: string
  efficiency: string
}

export interface PumpIteration {
  stageNo: string
  rs: string
  bg: string
  bo: string
  gasVolume: string
  chargePumpSepTFV: string
  chargePumpSepGOR: string
  chargePumpGLR: string
  chargePumpTotalPressure: string
  compositeSpGr: string
  chargePumpSepGVF: string
  chargePumpSepFreeGas: string
  liftStage: string
  bhpStage: string
}
export interface PumpModel {
  bepFlow: string
  bHPPerStage: string
  effeciency: string
  hsshaftHPLimit: string
  pumpID: string
  liftPerStage: string
  maximumOperatingBPD: string
  minimumOperatingBPD: string
  numberOfStages: string
  pumpName: string
  shaftDiameter: string
  standardShaftHPLimit: string
  totalBHP: string
  pumpImpellar: string
  pumpSeries: string
};

export type IPRMethodology = 'Vogel' | 'Composite' | 'ConstantPI' | 'Wiggins';

export interface PumpPressureShaft {
  HousingPressureLimit: string
  Pmax: string
};

export interface ProductivityIndexState {
  piVal: number | null;
  hiddenPressureHead: string | null;
  reservoirPressure: number | null;
  staticFluidLv1: number | null;
  staticFluidLv1_2: number | null;
}

export interface PressureState {
  staticBottomHolePressure: number | null;
  intakePressure: number | null;
  flowRate: number | null;
}

export interface HeadState {
  staticFluidLv1: number | null;
  producingFluidLevelSurface: number | null;
  flowRate: number | null;
}

export interface ProductionState {
  productionRate: number | null;
  pumpSetting: number | null;
  tvd: number | null;
  perforation: number | null;
  flopValue: number | null;
  settingDepth: number | null;
  reservoir: number | null;
  settingDepthReference: "Sensor" | "Intake" | "SetDepth";
};

export interface Tab1Input {
  casingID: string;
  casingDriftID: string;
  linerID: string;
  mySaveCheck: string;
  linerName: string;
  casingOD?: string | number;
  casingODList: any;
  casingWeight?: string | number;
  casingWeightList: object;
  linerOD?: string | number;
  linerODList: object;
  linerWeight: string | number;
  linerWeightList: object;
  linerTop: number;
  tubingOD?: string | number;
  tubingODList: object;
  tubingWeight: string | number;
  tubingWeightList: object;
  tubingID: string;
  tubingType: number;
  tubingTypeList: object;
  tubingTypeUpset: number;
  tubingTypeUpsetList: object;
  wellTrajectory: number;
  wellTrajectoryList: object;
  tangentSection: number;
  tangentAngle: number;
  tangentLength: number;
  projectIDNew: number;
  opType: string;
  unitSys: number;
  catalogType: number;
  motorSers: string;
  motorSersList: object;
  usrProjcts: string;
  usrProjctsList: object;
  unitCasingODListVal: string;
  unitCasingODList: object;
  unitCasingIDListVal: string;
  unitCasingIDList: object;
  unitCasingWeightListVal: string;
  unitCasingWeightList: object;
  unitLinerIDListVal: string;
  unitLinerIDList: object;
  unitLinerSizeListVal: string;
  unitLinerSizeList: object;
  unitLinerWeightListVal: string;
  unitLinerWeightList: object;
  unitTangentAngleListVal: string;
  unitTangentAngleList: object;
  unitTangentLengthListVal: string;
  unitTangentLengthList: object;
  unitTubingIDListVal: string;
  unitTubingIDList: object;
  unitTubingODListVal: string;
  unitTubingODList: object;
  unitTubingWeightListVal: string;
  unitTubingWeightList: object;
  unitLinerTopListVal: string;
  unitLinerTopList: object;
  actNameCasingOD: string;
  actNameCasingWeight: string;
  actNameCasingID: string;
  actNameLinerOD: string;
  actNameLinerWeight: string;
  actNameLinerID: string;
  actNameLinerTop: string;
  actNameTubingOD: string;
  actNameTubingWeight: string;
  actNameTubingID: string;
  actNameProtector_TStdShaftHp: string;
  actNameProtector_THSShaftHP: string;
  actNameProtector_CThrustForce: string;
  actNameProtector_CMaxLoad: string;
  actNameProtector_ShaftRating: string;
  actNameCable_ClearanceTubing: string;
  actNameCable_ClearancePump: string;
  actNameCable_ClearanceProtector: string;
  actNameCable_ClearanceMotor: string;
  actNameCable_EstCableLength: string;
  actNameCable_SurfaceCableLength: string;
  actNameCable_VoltageLoss: string;
  actNameCable_SurfaceVoltage: string;
  actNameMotor_HP: string;
  actNameMotor_TMotorOD: string;
  actNameMotor_TPower: string;
  actNameMotor_TVoltage: string;
  actNameMotor_TCurrent: string;
  actNameMotor_TBHTemp: string;
  actNameMotor_TOperatingTemp: string;
  actNameMotor_TBaseHP: string;
  actNameMotor_T1Current: string;
  actNameMotor_T1Voltage: string;
  actNameMotor_T1MotorLoad: string;
  actNameMotor_T1Speed: string;
  actNameMotor_T1OperatingTemp: string;
  actNameMotor_VFluidPastMotor: string;
  actNameMotor_VShroudOD: string;
  actNameMotor_ShroudWeight: string;
  actNameMotor_VFluidPastMotorShroud: string;
  actNameMotor_VCurrentDemand: string;
  actNamePump_MinFlow: string;
  actNamePump_BEPFlow: string;
  actNamePump_MaxFlow: string;
  actNamePump_TLiftPerStage: string;
  actNamePump_TBHPPerStage: string;
  actNamePump_TEfficiency: string;
  actNamePump_TBHPTotal: string;
  actNamePump_TStdShaftHP: string;
  actNamePump_THSShaftHP: string;
  actNamePump_TShaftDia: string;
  actNamePump_Pmax: string;
  actNamePump_PressureLimit: string;
  actNamePump_IFreeGas: string;
  actNamePump_IFreeGasPercent: string;
  actNamePump_IGLR: string;
  actNamePump_IGOR: string;
  actNamePump_IGVF: string;
  actNamePump_IPIP: string;
  actNamePump_IPSIPerStage: string;
  actNamePump_ITFV: string;
  actNameSurface_SurfaceVoltage: string;
  actNameSurface_KVA: string;
  actNameSurface_SupplyVoltage: string;
  actNameSurface_DriveAmps: string;
  actNameSurface_CostPerHour: string;
  actNameSurface_BasicCost: string;
  actNameSurface_TVSDWeight: string;
  hiddenPumpID: string;
  hdnPmpShowAll: string;
  hiddenNoOfGasSeps: string;
  hiddenUseOfChPmp: string;
  hiddenChrgePmpUsed: string;
  hiddenGasSepSelctd: string;
  hiddenGKXSelctd: string;
  hiddenChPmpSelcd: string;
  hiddenChPmp2Selcd: string;
  hiddenChPmp3Selcd: string;
  hiddenHeadPrStg?: number;
  hiddenDesrdStg?: number;
  hiddenDesrdStg2?: number;
  hiddenDesrdStg3?: number;
  hiddenSep1Eff?: number;
  hiddenSep2Eff?: number;
  hiddenSep3Eff?: number;
  hiddenSep4Eff?: number;
  chargePumpShowAll: boolean;
  hiddenAnchorOD?: number;
  hiddenAnchorTubingOD?: number;
  hiddenTubngOD: string;
  hiddenMotrID: string;
  hiddenMotrHP?: number;
  hiddenMotr60HP?: number;
  hiddenWthrMotrShrd: string;
  hiddenMotrShrdOD: string;
  hiddenMotrShrdWght: string;
  hdnMotrAutoHP: string;
  hdnMotrShowAll: string;
  hiddenMotrSers: string;
  hdnMotr_Sensr: number;
  hdnMainCableLckPlate: string;
  hiddenCable_Type: string;
  hiddenCable_MtrLead: string;
  hiddenCable_LckPlate: string;
  hiddenGasDesign: string;
  hiddenGasAutoEff: string;
  hiddenGasNatrEffAuto: string;
  hdnUnitReservoirHeadListVal: string;
  hdnUnitIntakeHeadListVal: string;
  hdnUnitMaxFlowRateListVal: string;
  hdnUnitAdditionalBPDListVal: string;
  hdnUnitBasicPIListVal: string;
  hdnUnitTubingHeadListVal: string;
  hdnUnitFrictionLossListVal: string;
  hdnUnitProductionLevelListVal: string;
  hdnUnitTDHListVal: string;
  hdnUnitPIPListVal: string;
  hdnUnitAnchorIDListVal: string;
  hdnUnitAnchorODListVal: string;
  hdnUnitAnchorTubngODListVal: string;
  hdnGas_SeparatorHP: string;
  hdnGas_ChargePumpHP: string;
  hdnGas_HeadPerStage: string;
  hdnGas_SeparationEfficiency: string;
  hdnUnitPressGrdnt: string;
  hdnGas_TotalFluidVolume: string;
  hdnGas_FreeGas: string;
  hdnGas_GOR: string;
  hdnGas_GLR: string;
  hdnGas_GVF: string;
  hdnGas_VolumeInjested: string;
  hdnGas_LiquidVolumetricRate: string;
  hdnUnitLiqPhseDens: string;
  hdnGas_PressureContribution: string;
  hdnGas_TotalPressure: string;
  hdnGas_Rs: string;
  hdnGas_Bg: string;
  hdnGas_Bo: string;
  hdnUnitPump_MotorFullSpeed: string;
  hdnUnitPump_LiftPerStage: string;
  hdnUnitPump_HP3500: string;
  hdnUnitPump_MinFlow: string;
  hdnUnitPump_BEPFlow: string;
  hdnUnitPump_MaxFlow: string;
  hdnUnitPump_TLiftPerStage: string;
  hdnUnitPump_TBHPPerStage: string;
  hdnUnitPump_TEfficiency: string;
  hdnUnitPump_TBHPTotal: string;
  hdnUnitPump_TStdShaftHP: string;
  hdnUnitPump_THSShaftHP: string;
  hdnUnitPump_TShaftDia: string;
  hdnUnitPump_Pmax: string;
  hdnUnitPump_PressureLimit: string;
  hdnUnitPump_IFreeGas: string;
  hdnUnitPump_IFreeGasPercent: string;
  hdnUnitPump_IGLR: string;
  hdnUnitPump_IGOR: string;
  hdnUnitPump_IGVF: string;
  hdnUnitPump_IPIP: string;
  HdnUnitPump_IPSIPerStage: string;
  hdnUnitPump_ITFV: string;
  hdnUnitMotor_HP: string;
  hdnUnitMotor_TMotorOD: string;
  hdnUnitMotor_TPower: string;
  hdnUnitMotor_TVoltage: string;
  hdnUnitMotor_TCurrent: string;
  hdnUnitMotor_TBHTemp: string;
  hdnUnitMotor_TOperatingTemp: string;
  hdnUnitMotor_TBaseHP: string;
  hdnUnitMotor_T1Current: string;
  hdnUnitMotor_T1Voltage: string;
  hdnUnitMotor_T1MotorLoad: string;
  hdnUnitMotor_T1Speed: string;
  hdnUnitMotor_T1OperatingTemp: string;
  hdnUnitMotor_VFluidPastMotor: string;
  hdnUnitMotor_VShroudOD: string;
  hdnUnitMotor_ShroudODWeight: string;
  hdnUnitMotor_VFluidPastMotorShroud: string;
  hdnUnitMotor_VCurrentDemand: string;
  hdnUnitProt_TStdShHP: string;
  hdnUnitProt_THSShHP: string;
  hdnUnitProt_CThFrc: string;
  hdnUnitProt_CMxLd: string;
  hdnUnitProt_ShRatng: string;
  hdnUnitCable_ClrTubng: string;
  hdnUnitCable_ClrPmp: string;
  hdnUnitCable_ClrProt: string;
  hdnUnitCable_ClrMotr: string;
  hdnUnitCable_EstLng: string;
  hdnUnitCable_SurfCablLng: string;
  hdnUnitCable_VltLss: string;
  hdnUnitCable_SurfVolt: string;
  hdnUnitSurface_SurfVolt: string;
  hdnUnitSurface_KVA: string;
  hdnUnitSurface_SuplVolt: string;
  hdnUnitSurface_DrvAmps: string;
  hdnUnitSurface_CstPrHr: string;
  hdnUnitSurface_BasicCst: string;
  hdnUnitSurface_TVSWeight: string;
  hdnCreatedDate?: Date;
  hdnUpdatedDate?: Date;
  hdnCreatedBy: string;
  hdnUpdatedBy: string;
  hdn_Pump_ShaftType: string;
  hdn_Pump_HousingType: string;
  hdnCable_CableType: string;
  hdnCable_MotorLead: string;
  hdnCable_LockPlate: string;
  hdnCable_IsDriftID: boolean;
  hdnCable_PumpLockPlate: boolean;
  hdnCable_SealLockPlate: boolean;
  hdnCable_MotorLockPlate: boolean;
  hdnCable_EstCabLng?: number;
  hdnCable_SurfCabl?: number;
  hdnProtector_Protector1: string;
  hdnProtector_Protector2: string;
  hdnProtector_Protector1HP?: number;
  hdnProtector_Protector2HP?: number;
  hdnProtector_ShaftType?: number;
  hdnProtector_BearingType?: number;
  hdnProtector_OilType?: number;
  hiddenProtSers: string;
  hdnSurface_SuplVlt?: number;
  hdnSurface_CstPrHr?: number;
  hdnSurface_PwrFactr?: number;
  hdnSurface_Efficiency?: number;
  actNameBasic_MaxFlowRate: string;
  actNameBasic_AdditionalBPD: string;
  actNameBasic_PI: string;
  myTabSelected: string;
  hdnTemplateID: string;
  hdnTemplateName: string;
  hdnUservLevel: string;
  hdnMotrCurrent: string;
  hiddenSurfVSD: string;
  hiddenSwtchBrd: string;
  hdnCntrlTyp: string;
  hdnSurf_Cntrlr: string;
  inputCasingODDescription: string;
  inputCasingODLink: string;
  inputCasingODClass: string;
  inputCasingWeight: string;
  inputCasingID: string;
  inputLinerOD: string;
  inputLinerWeight: string;
  inputLinerID: string;
  inputLinerTop: string;
  inputTubingOD: string;
  inputTubingType: string;
  inputTubingWeight: string;
  inputTubingID: string;
  inputWellTrajectory: string;
  inputDescription: string;
  className: string;
  helpCasingOD: HelpOutObject;
  helpCasingID: HelpOutObject;
  helpCasingWeight: HelpOutObject;
  helpLinerOD: HelpOutObject;
  helpLinerWeight: HelpOutObject;
  helpLinerID: HelpOutObject;
  helpLinerTop: HelpOutObject;
  helpTubingOD: HelpOutObject;
  helpTubingType: HelpOutObject;
  helpTubingWeight: HelpOutObject;
  helpTubingID: HelpOutObject;
  helpTubing: HelpOutObject;
  helpWellTrajectory: HelpOutObject;
};

export interface Tab2Input {
  tubingPressure?: number;
  casingPressure?: number;
  sbhpForPressre: number;
  flowRate?: number;
  productionRate?: number;
  helpPumpSettingMeasured: number;
  helpPumpSettingVertical: number;
  reservoirPressure?: number | null;
  inflowType: string;
  inflowTypeLstVal: string;
  piVal?: number;
  unitPIValListVal: string;
  intakePressure?: number;
  isPressure: boolean;
  isHead: boolean;
  flowRateForHd?: number;
  pumpSetting?: number;
  perforation?: number;
  tvd?: number;
  flop?: number | null;
  staticFluidLvl?: number;
  staticFluidLvlForHd?: number;
  prdcngFluidLvl?: number;
  unitCasingPressureListVal: string;
  unitCasingPressureList: object;
  unitFLOPListVal: string;
  unitFLOPList: object;
  unitFlowRateListVal: string;
  unitFlowRateList: object;
  unitIntakePressureListVal: string;
  unitIntakePressureList: object;
  unitPerforationListVal: string;
  unitPerforationList: object;
  unitProductionRateListVal: string;
  unitProductionRateList: object;
  unitPumpSettingListVal: string;
  unitPumpSettingList: object;
  unitReservoirPressureListVal: string;
  unitReservoirPressureList: object;
  unitTVDListVal: string;
  unitTVDList: object;
  unitTubingPressureListVal: string;
  unitTubingPressureList: object;
  unitStaticFluidLvlListVal: string;
  unitPrdcngFluidLvlListVal: string;
  actNameTubingPressure: string;
  actNameCasingPressure: string;
  actNamePI: string;
  actNameFlowRate: string;
  actNameProductionRate: string;
  actNamePumpSettingMeasured: string;
  actNamePumpSettingVertical: string;
  actNamePerforation: string;
  actNameFLOP: string;
  actNameSBHP: string;
  actNameFBHP: string;
  actNameStaticFluidLevel: string;
  actNameProducingFluidLevel: string;
  hiddenPresHeadIPType: string;
  hiddenPresHeadPIIPType: string;
};

export interface Tab5Input {
  suplVlt?: string | number;
  availKVA?: number;
  oxygenVal?: number;
  nitrogenVal?: number;
  h2S?: number;
  cO2?: number;
  additnalNotes: string;
  unitSuplPwrListVal: string;
  unitSuplPwrList: any;
  unitContrlListVal: string;
  unitContrlList: any;
  unitCorsnListVal: string;
  unitCorsnList: any;
  paraffin: string;
  scale: string;
  sandSolids: string;
  viscostyEmulsn: string;
  packerReqd: string;
  chemicalYN: string;
  yToolYN: string;
  scadayn: string;
  pressureSensYN: string;
}

export interface saveProjectPayload {
  Lifttype: number;
  ESPInputViewModel: object;
  ESPCalculation: object;
  FormCollection: object;
  basicCalculation: object;
  basicTDHCalculation: object;
  PumpModel: object;
  MotorInputModel: object;
  SurveyData: WellSurveyServerData[] | null;
  WellSurveyESPAssembly: object;
  region: string | null;
  ProjectData: object;
  ComparisonCaseId1: string | null;
  ComparisonCaseId2: string | null;
  ComparisonCaseId3: string | null;
  AIEnabled: boolean;
};

export interface WellSurveyServerData {
  MD: number;
  INC: number;
  DLS: number;
};
export interface StatFldChangePayload {
  StacFld: number;
  CombSpGr: number;
  InUnit: number;
  OutUnit: number;
  Perftn: number;
  PerftnUnit: number;
  casingPressure: number;
  casingPressureUnit: number;
}
export interface cableResponse {
  id: string;
  pn: number;
  pN_Description: string;
  nominalWeight: number;
  awG_id: number;
  profile: string;
  tempRating_C: number;
  voltRating_KV: number;
  insulation: string;
  barrier: string;
  armorMaterial: string;
  standardization: boolean;
  totalLength: number;
}
export interface cableRequestParams {
  awg_Id: number;
  length: number;
  catalogFilter: number;
}
export interface ProductionRate {
  bwpd: number | null;
  bopd: number | null;
}
export interface ProductionDataPayload {
  BOPDUnit: number;
  BWPDUnit: number;
  ProductionRate: number;
  ProductionRateUnit: number;
  WaterCut: number;
}

export interface BasicGasCalculation {
  gasDesign: string;
  gasDesignList: object;
  anchorOD: string;
  anchorODList: anchorODList;
  anchorID: string;
  tubingOD: string;
  anchorTubingODList: object;
  naturalEfficiency: string;
  separatorEfficiency: string;
  rs: string;
  bg: string;
  bo: string;
  oilVolume: string;
  waterVolume: string;
  totalFluidVolume: string;
  gor: string;
  naturalEfficiencyAnchor: string;
  gasVolIngested: string;
  liqVolmRate: string;
  totalFluidVolumeHand: string;
  freeGasPercentge: string;
  gvfPreSep: string;
  gorPreSep: string;
  glrPreSep: string;
  prePressGrad: string;
  liqdPhaseDensity: string;
  totalPIP: string;
  combinedSpGr: string;
  flop: string;
  chargePumpGKX: string | any;
  chargePumpGKXList: any[];
  chargePump: string | any;
  chargePumpList: any[];
  chargePump2: string;
  chargePumpList2: any[];
  chargePump3: string;
  chargePumpList3: any[];
  gkxFlowCorrection?: number;
  gkxHeadCorrection?: number;
  gkxPowerCorrection?: number;
  cP1FlowCorrection?: number;
  cP1HeadCorrection?: number;
  cP1PowerCorrection?: number;
  cP2FlowCorrection?: number;
  cP2HeadCorrection?: number;
  cP2PowerCorrection?: number;
  cP3FlowCorrection?: number;
  cP3HeadCorrection?: number;
  cP3PowerCorrection?: number;
  sepSelcted: string;
  separatorList: any[];
  noOfGasSeps: string;
  useOfChgPmp: string;
  useOfChgPmpNew: string;
  noOfStages: string;
  chargePumpHdPrStage: string;
  chargePumpDesrdStge: string | number;
  chargePumpDesrdStge2: string | number;
  chargePumpDesrdStge3: string | number;
  preAnchorNaturalEfficiency: string;
  preAnchorGOR: string;
  preAnchorGLR: string;
  preAnchorGVF: string;
  preAnchorFreeGas: string;
  preAnchorTFV: string;
  chrgePmpGasVolume: string;
  chargePmpSepTFV: string;
  chargePmpSepFreeGas: string;
  chargePmpSepGVF: string;
  chargePmpSepGOR: string;
  chargePmpPSI: string;
  chargePmpTotalPressure: string;
  chargePumpGLR: string;
  chargePumpPresGrad: string;
  unitAdditionalBPDListVal: string;
  unitAnchorIDListVal: string;
  unitPressGrdnt: string;
  unitLiqPhseDens: string;
  actNameGas_AnchorOD: string;
  actNameGas_AnchorID: string;
  actNameGas_AnchorTubingOD: string;
  actNameGas_SeparatorHP: string;
  actNameGas_ChargePumpHP: string;
  actNameGas_HeadPerStage: string;
  actNameGas_SeparationEfficiency: string;
  actNameGas_PressureGradient: string;
  actNameGas_TotalFluidVolume: string;
  actNameGas_FreeGas: string;
  actNameGas_GOR: string;
  actNameGas_GLR: string;
  actNameGas_GVF: string;
  actNameGas_VolumeInjested: string;
  actNameGas_LiquidVolumetricRate: string;
  actNameGas_LiquidPhaseDensity: string;
  actNameGas_PressureContribution: string;
  actNameGas_TotalPressure: string;
  actNameGas_Rs: string;
  actNameGas_Bg: string;
  actNameGas_Bo: string;
  actNameGas_GasVolume: string;
  actNameGas_OilVolume: string;
  actNameGas_WaterVolume: string;
  actNamebasic_Flop: string;
  actNameMotor_T1OperatingTemp: string;
  gasCompressblty: string;
  finTemp: string;
  gasIntakeNaturalSeparatorEfficiency?: number;
  chargePumpShowAll: boolean;
  hdn_GKX_ShaftType: number | string;
  hdn_ChargePump1_ShaftType: number
  hdn_ChargePump2_ShaftType: number
  hdn_ChargePump3_ShaftType: number
  EquipmentListForGasHandlers: any;
  EquipmentListForGasSeparator: any;
  EquipmentListForChargePumpOne: any;
  EquipmentListForChargePumpTwo: any;
  EquipmentListForChargePumpThree: any;
};

export interface DropDownObjectValueModel {
  [key: string]: Separator
};

export interface anchorODList {
  [key: string]: string;
};

interface Separator {
  id: string;
  series: string;
  seriesType: string;
};

export interface BasicGasCalculationCalculated {
  hPRating: string;
  gKX_HPRating: string;
};

export interface separatorListPayload {
  CasingID: number | null;
  TFV: number | null;
  UnitSys: number;
  CasingIDUnit: number;
  TFVUnt: number;
  catalogFilter: number;
};

export interface powerRatingPayload {
  SeparatorID: string;
  UnitSys: string;
};

export interface chargePumpPayload {
  CasingOD: string;
  TFV: string | number | null;
  UnitSys: string;
  TFVUnit: string;
  catalogFilter: number;
  chargePumpShowAll: boolean;
};

export interface anchorIDPayload {
  AcnhorOD: number | null;
  UnitSys: string;
};

export interface TFVWarningPayload {
  TFV: number | null;
  UnitSym: string;
  SepVal: string;
};

export interface GasCalculationData {
  bg?: number;
  bo?: number;
  compositeSpGr?: number;
  flop?: number;
  freeGas?: number;
  gasCompressibility?: number;
  gasVolume?: number;
  glr?: number;
  gor?: number;
  liquidPhaseDensity?: number;
  naturalSepEff?: number | string;
  oilVolume?: number;
  pip?: number;
  rs?: number;
  temperatureOut?: number;
  tfv?: number;
  waterVolume?: number;
  liquidPhaseSpGr?: number;
  gvf?: number;
};

export interface gasPowerRating {
  hPRating: string;
  gKX_HPRating?: string;
};

export interface PumpCapacityCurveHeadSample {
  capacity: number;
  head: number;
};

export interface PumpCapacityCurveBHPSample {
  capacity: number;
  bhp: number;
};

export interface PumpCapacityCurveEfficiencySample {
  capacity: number;
  efficiency: number;
};

export interface PumpCapacityCurveUnits {
  capacity: string;
  head: string;
  bhp: string;
  efficiency: string;
};

export interface PumpCapacityCurveMaxScales {
  capacity: number;
  head: number;
  bhp: number;
  efficiency: number;
};
export interface WellInflowData {
  mxFlowRate1: string;
  mxFlowRate2: string;
  mxFlowRate3: string;
  mxFlowRate4: string;
  addtionalBPD1: string;
  addtionalBPD2: string;
  addtionalBPD3: string;
  addtionalBPD4: string;
  piStrVal1: string;
  piStrVal2: string;
  piStrVal3: string;
  piStrVal4: string;
  fbhpStrVal1: string;
  fbhpStrVal2: string;
  fbhpStrVal3: string;
  fbhpStrVal4: string;
}

export interface IPRTableData {
  wellInflowData: WellInflowData[];
  iprSelected: string;
}

export interface WellSurveyData {
  projectId: string;
  md: number;
  inc: number;
  dls: number;

}

export interface DepletionCurveGraphData {
  wiggins: { liquidRate: number; fbhp: number }[];
  depletion10Percent: { liquidRate: number; fbhp: number }[];
  depletion20Percent: { liquidRate: number; fbhp: number }[];
  depletion30Percent: { liquidRate: number; fbhp: number }[];
  depletion40Percent: { liquidRate: number; fbhp: number }[];
  depletion50Percent: { liquidRate: number; fbhp: number }[];
  depletion60Percent: { liquidRate: number; fbhp: number }[];
  depletion70Percent: { liquidRate: number; fbhp: number }[];
  generalDepletion: { liquidRate: number; fbhp: number }[];
  x_Plot_MaxValue: number;
  y_Plot_MaxValue: number;
  x_Plot_Interval: number;
  y_Plot_Interval: number;
}
export interface PumpCapacityCurveGraphData {
  head: PumpCapacityCurveHeadSample[];
  bhp: PumpCapacityCurveBHPSample[];
  efficiency: PumpCapacityCurveEfficiencySample[];
  units: PumpCapacityCurveUnits;
  maxScales: PumpCapacityCurveMaxScales;
  target: PumpCapacityCurveHeadSample[];
  targetV: PumpCapacityCurveHeadSample[];
  targetH: PumpCapacityCurveHeadSample[];
  minBHP: PumpCapacityCurveHeadSample[];
  bepbhp: PumpCapacityCurveHeadSample[];
  maxBHP: PumpCapacityCurveHeadSample[];
};

export interface SpecialPumpCalculationOutput {
  desiredStages: number;
  targetFlowRate: number;
  liftPerStage: number;
  finalTDH: number;
  totalPower: number;
  efficiency: number;
  shaftLoad: number;
};

export interface onCalculatePayload {
  tdhValues: TDHInObject;
  gasCalcValues: GasFlowInObject;
  chrgePmpVals: object;
  catalogFilter: number;
};

export interface TDHInObject {
  spGrWater: number | null;
  tubingPressure: number | null;
  tubingPressureUnit: number;
  tubingID: number | null;
  tubingIDUnit: number;
  tubingAge: number | null;
  pumpSetting: number | null;
  pumpSettingUnit: number;
  productionRate: number | null;
  productionRateUnit: number;
  tVD: number | null;
  tVDUnit: number;
  fLOP: number | null;
  fLOPUnit: number;
  combinedSpGr: number | null;
  casingPressure: number | null;
  casingPressureUnit: number;
  unitSystem: number;
  finalPIP: number | null;
  casingOD: number;
};

export interface GasFlowInObject {
  casingID: number;
  casingIDUnit: number;
  tubingOD: number;
  productionRate: number;
  productionRateUnit: number;
  spGrWater: number;
  waterCut: number;
  combinedSpGr: number;
  liquidPhaseSpGr: number;
  bWPD: number;
  bWPDUnit: number;
  oilAPI: number;
  spGrOil: number;
  bOPD: number;
  bOPDUnit: number;
  spGrGas: number;
  gOR: number | null;
  gORUnit: number;
  bottomHoleTemp: number | null;
  bottomHoleTempUnit: number;
  gasDesign: number;
  anchorOD: number | null;
  anchorID: number | null;
  anchorTubingOD: number | null;
  unitSystem: number;
  bubblePointPressure: number;
  bubblePointPressureUnit: number;
  isNatural: boolean;
  fLOP: number;
  fLOPUnit: number;
  perforation: number;
  perforationUnit: number;
  pumpSetting: number;
  pumpSettingUnit: number;
  casingPressure: number;
  casingPressureUnit: number;
  isGas: boolean;
  gasCompressibility: number | null;
  gasProduction: number | null;
  gasProductionUnit: number;
  staticBHP: number;
  staticFluidLevel: number;
  inflowType: number;
  projectId: string;
  intakeNaturalSeparatorEff: number | null;
  chargePumpShowAll: boolean;
  regionName: string;
};

export interface GasCalculationOutPut {
  IsTFV_SepWarningVisible?: boolean;
  Anchor_SeperatorEff?: number | string;
  Anchor_NaturalSeperatorEff?: number | string;
  Anchor_Rs?: number;
  Anchor_Bg?: number;
  Anchor_Bo?: number;
  Anchor_VolumeOfGas?: number;
  Anchor_VolumeOfOil?: number;
  Anchor_VolumeOfWater?: number;
  Anchor_TotalFluidVolume?: number;
  Anchor_FreeGas?: number;
  Anchor_GOR?: number;
  Anchor_GLR?: number;
  Anchor_GVF?: number;
  Anchor_LiquidPhaseDensity?: number;
  Anchor_GasCompressibility?: number;
  Anchor_Pressure?: number;
  Anchor_FinalComposite_SpGr?: number;
  Anchor_FinalFLOP?: number;
  Anchor_FinalTemperature?: number;
  Anchor_LiquidPhaseSpGr?: number;
  Intake_SeperatorEff?: number | string;
  Intake_NaturalSeperatorEff: number | string;
  ChargePumpShowAll?: boolean
  Intake_Rs: number;
  Intake_Bg: number;
  Intake_Bo: number;
  Intake_VolumeOfGas: number;
  Intake_VolumeOfOil: number;
  Intake_VolumeOfWater: number;
  Intake_TotalFluidVolume?: number;
  Intake_FreeGas: number;
  Intake_GOR: number;
  Intake_GLR: number;
  Intake_GVF: number;
  Intake_LiquidPhaseDensity: number;
  Intake_GasCompressibility?: number;
  Intake_Pressure: number;
  Intake_FinalComposite_SpGr?: number;
  Intake_FinalFLOP?: number;
  Intake_FinalTemperature?: number;
  Intake_LiquidPhaseSpGr?: number;
  SP1_NaturalSeperatorEff?: number;
  SP1_Rs?: number;
  SP1_Bg?: number;
  SP1_Bo?: number;
  SP1_VolumeOfGas?: number;
  SP1_VolumeOfOil?: number;
  SP1_VolumeOfWater?: number;
  SP1_TotalFluidVolume?: number;
  SP1_FreeGas?: number;
  SP1_GOR?: number;
  SP1_GLR?: number;
  SP1_GVF?: number;
  SP1_LiquidPhaseDensity?: number;
  SP1_GasCompressibility?: number;
  SP1_Pressure?: number;
  SP1_FinalComposite_SpGr?: number;
  SP1_FinalFLOP?: number;
  SP1_FinalTemperature?: number;
  SP1_LiquidPhaseSpGr?: number;

  SP2_NaturalSeperatorEff?: number;
  SP2_Rs?: number;
  SP2_Bg?: number;
  SP2_Bo?: number;
  SP2_VolumeOfGas?: number;
  SP2_VolumeOfOil?: number;
  SP2_VolumeOfWater?: number;
  SP2_TotalFluidVolume?: number;
  SP2_FreeGas?: number;
  SP2_GOR?: number;
  SP2_GLR?: number;
  SP2_GVF?: number;
  SP2_LiquidPhaseDensity?: number;
  SP2_GasCompressibility?: number;
  SP2_Pressure?: number;
  SP2_FinalComposite_SpGr?: number;
  SP2_FinalFLOP?: number;
  SP2_FinalTemperature?: number;
  SP2_LiquidPhaseSpGr?: number;

  SP3_NaturalSeperatorEff?: number;
  SP3_Rs?: number;
  SP3_Bg?: number;
  SP3_Bo?: number;
  SP3_VolumeOfGas?: number;
  SP3_VolumeOfOil?: number;
  SP3_VolumeOfWater?: number;
  SP3_TotalFluidVolume?: number;
  SP3_FreeGas?: number;
  SP3_GOR?: number;
  SP3_GLR?: number;
  SP3_GVF?: number;
  SP3_LiquidPhaseDensity?: number;
  SP3_GasCompressibility?: number;
  SP3_Pressure?: number;
  SP3_FinalComposite_SpGr?: number;
  SP3_FinalFLOP?: number;
  SP3_FinalTemperature?: number;
  SP3_LiquidPhaseSpGr?: number;

  SP4_NaturalSeperatorEff?: number;
  SP4_Rs?: number;
  SP4_Bg?: number;
  SP4_Bo?: number;
  SP4_VolumeOfGas?: number;
  SP4_VolumeOfOil?: number;
  SP4_VolumeOfWater?: number;
  SP4_TotalFluidVolume?: number;
  SP4_FreeGas?: number;
  SP4_GOR?: number;
  SP4_GLR?: number;
  SP4_GVF?: number;
  SP4_LiquidPhaseDensity?: number;
  SP4_GasCompressibility?: number;
  SP4_Pressure?: number;
  SP4_FinalComposite_SpGr?: number;
  SP4_FinalFLOP?: number;
  SP4_FinalTemperature?: number;
  SP4_LiquidPhaseSpGr?: number;

  GKX_SeperatorEff?: number;
  GKX_NaturalSeperatorEff?: number;
  GKX_Rs?: number;
  GKX_Bg?: number;
  GKX_Bo?: number;
  GKX_VolumeOfGas?: number;
  GKX_VolumeOfOil?: number;
  GKX_VolumeOfWater?: number;
  GKX_TotalFluidVolume?: number;
  GKX_FreeGas?: number;
  GKX_GOR?: number;
  GKX_GLR?: number;
  GKX_GVF?: number;
  GKX_LiquidPhaseDensity?: number;
  GKX_GasCompressibility?: number;
  GKX_Pressure?: number;
  GKX_FinalComposite_SpGr?: number;
  GKX_FinalFLOP?: number;
  GKX_FinalTemperature?: number;
  GKX_HPRating?: number;
  GKX_FlowCorrection?: number;
  GKX_HeadCorrection?: number;
  GKX_PowerCorrection?: number;
  GKX_LiquidPhaseSpGr?: number;

  CP1_SeperatorEff?: number;
  CP1_NaturalSeperatorEff?: number;
  CP1_Rs?: number;
  CP1_Bg?: number;
  CP1_Bo?: number;
  CP1_VolumeOfGas?: number;
  CP1_VolumeOfOil?: number;
  CP1_VolumeOfWater?: number;
  CP1_TotalFluidVolume?: number;
  CP1_FreeGas?: number;
  CP1_GOR?: number;
  CP1_GLR?: number;
  CP1_GVF?: number;
  CP1_LiquidPhaseDensity?: number;
  CP1_GasCompressibility?: number;
  CP1_Pressure?: number;
  CP1_FinalComposite_SpGr?: number;
  CP1_FinalFLOP?: number;
  CP1_FinalTemperature?: number;
  CP1_HPRating?: number;
  CP1_FlowCorrection?: number;
  CP1_HeadCorrection?: number;
  CP1_PowerCorrection?: number;
  CP1_LiquidPhaseSpGr?: number;

  CP2_SeperatorEff?: number;
  CP2_NaturalSeperatorEff?: number;
  CP2_Rs?: number;
  CP2_Bg?: number;
  CP2_Bo?: number;
  CP2_VolumeOfGas?: number;
  CP2_VolumeOfOil?: number;
  CP2_VolumeOfWater?: number;
  CP2_TotalFluidVolume?: number;
  CP2_FreeGas?: number;
  CP2_GOR?: number;
  CP2_GLR?: number;
  CP2_GVF?: number;
  CP2_LiquidPhaseDensity?: number;
  CP2_GasCompressibility?: number;
  CP2_Pressure?: number;
  CP2_FinalComposite_SpGr?: number;
  CP2_FinalFLOP?: number;
  CP2_FinalTemperature?: number;
  CP2_HPRating?: number;
  CP2_FlowCorrection?: number;
  CP2_HeadCorrection?: number;
  CP2_PowerCorrection?: number;
  CP2_LiquidPhaseSpGr?: number;

  CP3_SeperatorEff?: number;
  CP3_NaturalSeperatorEff?: number;
  CP3_Rs?: number;
  CP3_Bg?: number;
  CP3_Bo?: number;
  CP3_VolumeOfGas?: number;
  CP3_VolumeOfOil?: number;
  CP3_VolumeOfWater?: number;
  CP3_TotalFluidVolume?: number;
  CP3_FreeGas?: number;
  CP3_GOR?: number;
  CP3_GLR?: number;
  CP3_GVF?: number;
  CP3_LiquidPhaseDensity?: number;
  CP3_GasCompressibility?: number;
  CP3_Pressure?: number;
  CP3_FinalComposite_SpGr?: number;
  CP3_FinalFLOP?: number;
  CP3_FinalTemperature?: number;
  CP3_HPRating?: number;
  CP3_FlowCorrection?: number;
  CP3_HeadCorrection?: number;
  CP3_PowerCorrection?: number;
  CP3_LiquidPhaseSpGr?: number;
};

export interface BasicTDHCalculation {
  tdhOverride?: string;
  tubingHead: string;
  frictionLoss: string;
  productionLevel: string;
  tdh: string;
  systemTDH?: string;
  pip: string;
  pipNew: string;
  desrdPIP?: string;
  newTDH?: string;
  unitTDHOverrideListVal?: string;
  unitTDHOverrideList?: object;
  unitTubingHeadListVal?: string;
  unitFrictionLossListVal?: string;
  unitProductionLevelListVal?: string;
  unitTDHListVal?: string;
  unitPIPListVal?: string;
  actNameBasic_TubingHead?: string;
  actNameBasic_TDH?: string;
  actNameBasic_FrictionLoss?: string;
  actNameBasic_ProductionLevel?: string;
  actNameBasic_PIP?: string;
  actNamebasic_Flop?: string;
  actNameGas_TotalPressure?: string;
};

export interface WellInflowInfo {
  calMethod: string;
  reserviorHead1?: string | null;
  reserviorHead2?: string | null;
  reserviorHead3?: string | null;
  reserviorHead4?: string | null;

  intakeHead1?: string | null;
  intakeHead2?: string | null;
  intakeHead3?: string | null;
  intakeHead4?: string | null;

  mxFlowRate1?: string | null;
  mxFlowRate2?: string | null;
  mxFlowRate3?: string | null;
  mxFlowRate4?: string | null;

  addtionalBPD1?: string | null;
  addtionalBPD2?: string | null;
  addtionalBPD3?: string | null;
  addtionalBPD4?: string | null;

  piStrVal1?: string | null;
  piStrVal2?: string | null;
  piStrVal3?: string | null;
  piStrVal4?: string | null;

  fbhpStrVal1?: string | null;
  fbhpStrVal2?: string | null;
  fbhpStrVal3?: string | null;
  fbhpStrVal4?: string | null;
};

export interface BasicWellInflowCalculation {
  calMethod: string;
  calMethodList?: object;
  reservoirHead?: number;
  intakeHead?: number;
  maxFlowRate?: number;
  additionalBPD?: number;
  unitReservoirHeadListVal: string;
  unitIntakeHeadListVal: string;
  unitMaxFlowRateListVal: string;
  unitAdditionalBPDListVal: string;
  actNameBasic_ReservoirHead: string;
  actNameBasic_IntakeHead: string;
};

export interface InflowData {
  shutInPressure: number;
  productionRate: number;
  depletion: number;
}

export interface TdhCalculations {
  tubingHead: number;
  frictionLoss: number;
  productionLevel: number;
  tdh: number;
  systemTDH: number;
  flop: number;
  finalPIP: number;
}

export interface BasicCalculationState {
  inflowData: InflowData | null;
  tdhData: TdhCalculations | null;
  depletionCurve: DepletionCurveGraphData | null;
  loading: boolean;
  error: string | null;
}
export interface TdhCalculations {
  tubingHead: number;
  frictionLoss: number;
  productionLevel: number;
  tdh: number;
  systemTDH: number;
  flop: number;
  finalPIP: number;
}

export interface DepletionCurveData {
  wiggins: { liquidRate: number; fbhp: number }[];
  depletion10Percent: { liquidRate: number; fbhp: number }[];
  depletion20Percent: { liquidRate: number; fbhp: number }[];
  depletion30Percent: { liquidRate: number; fbhp: number }[];
  depletion40Percent: { liquidRate: number; fbhp: number }[];
  depletion50Percent: { liquidRate: number; fbhp: number }[];
  depletion60Percent: { liquidRate: number; fbhp: number }[];
  depletion70Percent: { liquidRate: number; fbhp: number }[];
  generalDepletion: { liquidRate: number; fbhp: number }[];
  x_Plot_MaxValue: number;
  y_Plot_MaxValue: number;
}
export interface IPRGraphPoint {
  fbhp: number;
  liquidRate: number;
}

export interface IPRGraphData {
  wiggins: IPRGraphPoint[];
  vogel: IPRGraphPoint[];
  constantPi: IPRGraphPoint[];
  compositePi: IPRGraphPoint[];
  x_Plot_MaxValue: number;
  y_PlotMaxValue: number;
  x_Plot_Interval: number;
  y_Plot_Interval: number;
}


export interface IPRGraphPayload {
  InflowType: number;
  StaticBHPressure: string;
  StaticBHPressureUnit: string;
  PI: string;
  PIUnit: string;
  BubblePtPressure: string;
  BubblePtPressureUnit: string;
  ProductionRate: number;
  ProductionRateUnit: string;
  FlowingBHPressure: string | null;
  FlowingBHPressureUnit: string | null;
  FlowRate: string | null;
  FlowRateUnit: string | null;
  WaterCut: number;
  StaticBHHead: string;
  StaticBHHeadUnit: string;
  FlowingBHHead: string | null;
  FlowingBHHeadUnit: string | null;
  CombinedSpGr: number;
  Perforation: number;
  PerforationUnit: string;
  UnitSystem: string;
  IsGas: boolean;
}


// **Payload for Fetching Depletion Curve**
export interface DepletionCurvePayload {
  CombinedSpGr: number;
  CompositeMaxFlowRate?: number | null;
  DepletionPercent: number;
  FlowBHHeadFlowBHHead?: number | null;
  FlowingBHPressure?: number | null;
  InflowType: number;
  PI: string;
  Perforation: number;
  ProductionRate: number;
  StaticBHHead: string;
  StaticBHP: string;
  TestFlowRate?: number | null;
  UnitSystem: string;
  VogelMaxFlowRate?: number | null;
  WaterCut: number;
};

export interface DepletionPercentageInObject {
  staticBHP: number;
  staticFluidLevel: number;
  compositeSpGr: number;
  casingPressure: number;
  inflowType: number;
  datum: number;
  depletionPressure: number;
};

export interface FutureBHPInObject {
  staticBHP: number;
  inflowType: number;
  futureProductionRate: number;
  PI: number;
  maxFlowRate: number;
  futureShutInPressure: number;
  selectedIPR: IPR;
  combinedSpGr: number;
  staticBHHd: number;
  perforation: number;
};

export enum IPR {
  Wiggins = 0,
  Vogel = 1,
  Composite = 2,
  ConstantPI = 3
};

export interface BasicWellIPRCalculation {
  depletionPressure: number;
  futureProductionRate: number;
  showIPRPlotInMainReport?: boolean;
  showDepletionPlotInMainReport?: boolean;
};

export interface GasSeparatorEquipmentsPayload {
  series: any;
  seriesType: any;
  catalogFilter: number;
};

export interface GasHandlerEquipmentsPayload {
  pumpName: string;
  catalogFilter: string | number;
}

export interface Equipment {
  id: string;
  pump?: string;
  series?: string;
  name?: string;
  boh?: string;
  partNumber?: number;
  pN_Description?: string;
  length?: number;
  weight?: number;
  standardization?: boolean;
  noStgs?: number;
  text?: string;
  aalS_Description?: string;
  configuration?: string;
  bearingType?: string;
  shaftMaterial?: string;
  sensorId?: string;
  equipmentStatus?: string;
  international?: boolean;
  permian?: boolean;
  diameter?: string;
  parentId?: string;
  equipmentjson?: string;
  setDepth?: number;
  pn?: number | string;
  equipmentName?: string;
  equipmentId?: string;
  totalLength?: number;
  dimensions?: string;
  nominalWeight?: number;
  oracle_Item_Number?: number | string;
  transformers?: string;
  od?: number;
  size?: number;
  current?: number;
  voltage?: number;
  dimension?: string;
  kva?: number;
  sec?: number;
  sec_Y?: number;
  accBelowESP?: string;
  accAboveESP?: string;
  equipments?: string;
  shaftType?: string
  originalNominalWeight?: number;
  label?: string;
  value?: string;
  mle?: string;
};

export interface GasSepEfficiencyPayload {
  sepID: string;
  GVF: number;
  TFV: number;
  UnitSys: string;
  TFVUnt: string;
};

export interface GasSeperatorData {
  sepGasVolume: number;
  sepTFV: number;
  sepFreeGas?: number;
  sepGOR?: number;
  sepGLR?: number;
  sepGVF?: number;
  rs: number;
  bg: number;
  bo: number;
  sepOilVolume: number;
  sepWaterVolume: number;
  pip: number;
  compositeSpGr: number;
  flop: number;
  gasCompressibility: number;
  temperatureOut: number;
  liquidPhaseDensity: number;
  liquidPhaseSpGr: number
};

export interface GasEffChangePayload {
  GasEff: number;
  GasSepIPVals: (string | number | boolean | null | undefined)[]
};

export interface WellDetailsPayload {
  pageNumber: number;
  pageSize: number;
  searchTerm: string;
  SortBy: string;
  SortDirection: string | number;
}

export interface CustomerDetailsPayload {
  pageNumber: number;
  pageSize: number;
  SearchTerm_Contains: string;
  SortBy: string;
  SortDirection: string | number;
}

export interface GKXListPayload {
  TFV: number | string;
  unitSys: string;
  catalogFilter: number;
}

export interface GetChargePumpListPayload {
  CasingOD: string;
  TFV: number;
  UnitSys: string | number | null;
  TFVUnit: number;
  catalogFilter: number;
  chargePumpShowAll: boolean;
}

export interface FetchEquipmentsForHanderPayload {
  pumpName: string;
  catalogFilter: number;
};

export interface SpecialPumpCalculationOutputPayload {
  desiredStages: number;
  targetFlowRate: number;
  liftPerStage: number;
  finalTDH: number;
  totalPower: number;
  efficiency: number;
  shaftLoad: number;
};

export interface ChargePumpData {
  chargePumpSepTFV?: number;
  chargePumpSepFreeGas?: number;
  chargePumpSepGVF?: number;
  chargePumpSepGOR?: number;
  chargePumpTotalPressure: number;
  chargePumpGLR?: number;
  gasVolume?: number;
  oIlVolume?: number;
  waterVolume: number;
  rs?: number;
  bg?: number;
  bo?: number;
  compositeSpGr?: number;
  flop?: number;
  stageNo?: number;
  gasCompressibility?: number;
  hp?: number;
  temperatureOutput?: number;
  liquidPhaseDensity?: number;
  flowCorrection?: number;
  headCorrection?: number;
  powerCorrection?: number;
  liquidPhaseSpGr?: number;
};

export interface ChargePumps {
  Pump1: ChargePumpDetails | null;
  Pump2: ChargePumpDetails | null;
  Pump3: ChargePumpDetails | null;
};

export interface ChargePumpDetails {
  Id: string;
  NoOfStages: number;
  CorrectionFactors: {
    FlowCorrection: number;
    HeadCorrection: number;
    PowerCorrection: number;
  }
};

export interface ChargePumpCalculationInputs {
  UnitSystem: number;
  CasingPressure: number;
  ProductionRate: number;
  PumpSetting: number;
  Perforation: number;
  SpGrWater: number;
  WaterCut: number;
  BWPD: number;
  OilAPI: number;
  SpGrOil: number;
  BOPD: number;
  FluidViscosity: number;
  IsGasAvailable: boolean;
  SpGrGas: number;
  GasCompressibility: number;
  BubblePointPressure: number;
  BottomHoleTemp: number;
  Frequency: number;
  Flop: number;
  GOR: number;
  Bg: number;
  GasVolume: number;
  TFV: number;
  CompositeSpGravity: number;
  PIP: number;
  ChargePumps: ChargePumps | null;
  Units: {
    CasingPressureUnit: number;
    ProductionRateUnit: number;
    PumpSettingUnit: number;
    PerforationUnit: number;
    BWPDUnit: number;
    BOPDUnit: number;
    FluidViscosityUnit: number;
    GORUnit: number;
    BubblePointPressureUnit: number;
    BottomHoleTemperatureUnit: number;
  }
};
export interface GKXPumpCalculationInputs extends ChargePumpCalculationInputs {
  Pump: ChargePumpDetails | null;
};

export interface GKXPumpChangeOutput {
  gkxPump: GasPumpCalculations | null;
  chargePump1: GasPumpCalculations | null;
  chargePump2: GasPumpCalculations | null;
  chargePump3: GasPumpCalculations | null;
};

export interface GasCalculations {
  seperatorEfficiceny: number | null;
  naturalSeperatorEfficiceny: number | null;
  bg: number;
  bo: number;
  volumeOfGas: number;
  volumeOfOil: number;
  volumeOfWater: number;
  totalFluidVolume: number;
  freeGas: number;
  gor: number;
  glr: number;
  liquidPhaseDensity: number;
  gasCompessibility: number;
  pressure: number;
  compositeSpGr: number;
  liquidPhaseSpGr: number;
  flop: number;
  temperature: number;
  hp: number;
};

export interface GasPumpCalculations extends GasCalculations {
  flowCorrectionFactor: number;
  headCorrectionFactor: number;
  powerCorrectionFactor: number;
};

export interface FinalCalculatedData {
  preTFV: string
  finPIP: string
  compSPGr: string
  GOR: string
  temp: string
  FLOP: string
  BG: string
  GasVolm: string
  VolumeOfOil: string
  VolumeOfWater: string
  LiquidPhaseDensity: string
  FreeGasGvf: string
  Pressure: string
};

export interface CorrelationFactors {
  CorrectionFactors: {
    FlowCorrection: number;
    HeadCorrection: number;
    PowerCorrection: number;
  }
};

export interface fluidViscosityPayload {
  GOR: number
  BottomHoleTemperature: number;
  OilApi: number;
  GORUnit: number;
  BottomHoleTemperatureUnit: number;
};

export interface countyData {
  county: string;
  countryId: number;
};

export interface FLOPObject {
  perforation: number | null;
  perforationUnit: number;
  tVD: number | null;
  tVDUnit: number;
  pI: number | null;
  pIUnit: number;
  sBHP: number | null;
  sBHPUnit: number;
  fBHP: number | null;
  fBHPUnit: number;
  sBHH: number | null;
  sBHHUnit: number;
  fBHH: number | null;
  fBHHUnit: number;
  productionRate: number | null;
  productionRateUnit: number;
  flowRate: number | null;
  flowRateUnit: number;
  combinedSpGr: number | null;
  fLOPUnit: number;
  inflowType: number;
  casingPressure: number | null;
  casingPressureUnit: number;
  bubblePointPressure: number | null;
};

export interface SurfaceDto {
  current_InField: number
  current_OutField: number;
  descriptionField: string;
  enclosure: string;
  make: string;
  nameField: string;
  phaseField: number;
  powerField: number;
  pulse: number;
  voltageField: number;
  vsD_ID: string;
  weightField: string;
}

export interface SwitchBoardDto {
  control: string;
  description: string;
  switchBrdID: string;
  voltage: number;
}

export enum HarmonicFilterInstallationType {
  ReRun = 'ReRun',
  NWT = 'NWT'
}

export interface HarmonicFilterDto {
  id: string,
  name: string,
  loadPercentage: number,
  isRecommended: boolean,
  ampsFilter: number,
  harmPN?: number
}

export interface Equipment {
  id: string;
  pump?: string;
  series?: string;
  name?: string;
  partNumber?: number;
  pN_Description?: string;
  length?: number;
  weight?: number;
  standardization?: boolean;
  noStgs?: number;
  text?: string;
  aalS_Description?: string;
  configuration?: string;
  bearingType?: string;
  shaftMaterial?: string;
  sensorId?: string;
  equipmentStatus?: string;
  international?: boolean;
  permian?: boolean;
  diameter?: string;
  parentId?: string;
  equipmentjson?: string;
  setDepth?: number;
  pn?: number | string;
  equipmentName?: string;
  equipmentId?: string;
  totalLength?: number;
  dimensions?: string;
  nominalWeight?: number;
  oracle_Item_Number?: number | string;
  transformers?: string;
  od?: number;
  size?: number;
  current?: number;
  voltage?: number;
  dimension?: string;
  kva?: number;
  sec?: number;
  sec_Y?: number;
  accBelowESP?: string;
  accAboveESP?: string;
  equipments?: string;
  shaftType?: string
  originalNominalWeight?: number;
}


export interface HarmonicFiltersFilterCriterias {
  InstallationType: number,
  EstimatedCurrentAmps: number,
  VsdAmps: number,
  catalogFilter : number
}


export interface MotorLoadDifferentFrequencyRequest {
  rmsVsdVolt?: number,
  xformerMaxVolt?: number,
  minFrequency?: number,
  designFrequency?: number,
  maxFrequency?: number,
  vsdAmps?: number,
  motorNpAmp?: number,
  kva?: number,
  pumpBHp?: number,
  motorNPHP?: number,
  xformerCapacity?: number,
  totalVoltageDropMaxLoad?: number,
  motorNPVolts?: number
}

export class chartDataModel {
  PointValue?: PointF
  SeriesName?: string
  PointNo?: string
  Note?: string
}

export class PointF {
  IsEmpty?: boolean
  X?: number
  Y?: number
}

export interface CaseComparison {
  CaseId: string
  CaseType: string
  totalVolumeIntake: string
  oilRate: string
  oilRate_Unit: string
  gasRate: string
  gasRate_Unit: string
  waterRate: string
  waterRate_Unit: string
  freeGasIntakePercent: string
  pumpFreeGasPercent: string
  requiredSystemTDH: string
  pump_RequiredTDH: string
  pump_RequiredTDH_Unit: string
  gas_GasSeparator: string
  gasSep_FreeGasDischarge: string
  gasSep_TVFIntake: string
  gasSep_PressureIntake: string
  gasBOIPressureDischarge: string
  gasSep_TFVDischarge: string
  pump: string
  pump_TotalPower: string
  pumpNoOfStages: string
  pumpTDH: string
  pump_TFVIntake: string
  pump_FreeGasIntake: string
  gas_ChargePump1: string
  gas_ChargePump1_Stages: string
  chargePump1FinalTDH: string
  bhpChargPmp1Only: string
  chargPmp1_TFVIntake: string
  chargePump1_FreeGasIntake: string
  gas_ChargePump2: string
  gas_ChargePump2_Stages: string
  chargePump2FinalTDH: string
  bhpChargPmp2Only: string
  chargPmp2_TFVIntake: string
  chargePump2_FreeGasIntake: string
  gas_ChargePump3: string
  gas_ChargePump3_Stages: string
  chargePump3FinalTDH: string
  bhpChargPmp3Only: string
  chargPmp3_TFVIntake: string
  fc_FreeGasIntake: string
  gkx: string
  gkxNoOfStage: string
  gkxFinalTDH: string
  bhpGasHandlerOnly: string
  gkX_TFVIntake: string
  gkX_FreeGasIntake: string
  fC_FreeGasIntake: string,
  graph1Data: string,
  graph1DataHeadAxisTitle:string
  graph1DataCapacityAxisTitle : string,
  graph1DataPowerAxisTitle:string,
  graph1DataMajorStep:string,
  graph1DataMaximum:string,
  graph1DataEfficiencyMaximum:string,
  graph1DataEfficiencyMajorStep:string,
  graph1DataHeadMajorStep:string,
  graph1DataHeadMaximum:string,
  graph1DataPowerMajorStep:string,
  graph1DataPowerMaximum:string,
  surface_KvaRequired: string,
  motor_LoadAt60Hz: string,
  operatingFrequency: string,
  pumpSettingMD: string,
}